<template>
  <div class="fillheight datastore-main-edit-container" v-if="datastoreDetail">
    <v-sheet class="fillheight overflow-hidden pt-2 d-flex flex-row">
      <div class="fillheight flex-grow-1" style="width: 50%;">
        <DataStoreDetailMap
          ref="map"
          :datastoreDetail="datastoreDetail"
          @click:select="onSelectMap"
        >
        </DataStoreDetailMap>
      </div>
      <div class="fillheight" style="width: 50%; max-width: 50%;">
        <DataStoreDetailTable
          ref="table"
          :fields="fields"
          :id="datasetStoreDetailId"
          :version="datastoreDetail.version"
          @click:row="onClickItem"
          @click:update="onEditItem"
          @click:delete="onDeleteItem"
          @click:create="onCreateItem"
        />
      </div>
    </v-sheet>
    <FeatureEditDialog ref="featureEditDialog" :api="api" @success="onReset" />
    <FeatureImportDialog
      ref="featureImportDialog"
      :detail-id="datasetStoreDetailId"
      :fields="fields"
      @success="onReset"
    />
  </div>
</template>

<script>
import { API_BASEMAP, API_DATASTORE_DETAIL, API_FEATURE } from '@api'
import { ConfirmBuilder, replaceLink } from '@utils'
import { mapGetters } from 'vuex'
import DataStoreDetailMap from './map.vue'
import DataStoreDetailTable from './table.vue'
import FeatureEditDialog from './feature-edit-dialog.vue'
import FeatureImportDialog from './feature-import-dialog.vue'
import sdk from '@/src/service/auth-sdk/index.js'
export default {
  mixins: [],
  components: {
    DataStoreDetailMap,
    DataStoreDetailTable,
    FeatureEditDialog,
    FeatureImportDialog,
  },
  props: {
    option: { type: Object, default: () => ({ params: {} }) },
    workspace: {},
    id: [String, Number],
    datasetStoreDetailId: [String, Number],
  },
  data: (vm) => ({
    datastoreDetail: undefined,
    fields: [],
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_FEATURE.updateOption({
        url: replaceLink(API_FEATURE.getUrl(), {
          id: this.datasetStoreDetailId,
        }),
      })
    },
  },
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      if (!this.datasetStoreDetailId) {
        return
      }
      API_DATASTORE_DETAIL.getDetail(this.datasetStoreDetailId).then((res) => {
        if (res.error) {
          this.$router.replace({ name: 'workspaces' })
          return
        }
        this.datastoreDetail = res.data
        return sdk.request({
          url: `datastore-details/${this.datasetStoreDetailId}/fields`,
          method: 'get',
        })
      }).then((res) => {
        if (res && res.data) {
          this.fields = res.data
        }
      })
    },
    onClickItem(item) {
      if (this.$refs.map) {
        this.$refs.map.setHoverFeature(
          item ? item.id : null,
          item ? item.geometry : null
        )
      }
    },
    async fetchFeatureDetail(featureId) {
      if (featureId === undefined || featureId === null || featureId === '') {
        return null
      }
      const res = await this.api.getDetail(featureId)
      if (!res || res.error || !res.data) {
        return null
      }
      return res.data
    },
    async onSelectMap(props) {
      if (!props) {
        return
      }
      const { feature, action } = props
      const item = await this.fetchFeatureDetail(feature.id)
      if (!item) {
        return
      }
      switch (action) {
        case 'delete':
          this.onDeleteItem(item)
          break
        case 'update':
          this.onEditItem(item)
          break
      }
    },
    onEditItem(item) {
      if (this.$refs.featureEditDialog) {
        this.$refs.featureEditDialog.open({
          item,
          fields: this.fields,
        })
      }
    },
    onCreateItem() {
      if (this.$refs.featureImportDialog) {
        this.$refs.featureImportDialog.open()
      }
    },
    async onDeleteItem(item) {
      const field_name = this.datastoreDetail?.meta?.field_name
      let confirm = new ConfirmBuilder()
      confirm
        .addText(
          `Hành động này xóa đối tượng '<b>${(field_name && item[field_name]) ||
            item.name ||
            item.id}</b>' khỏi bộ dữ liệu`
        )
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await this.api.destroy(item.id)
        if (result && (result.isDone || result.data || !result.error)) {
          this.onReset()
        }
        return result
      }
    },
    onReset() {
      this.getData()
      this.$nextTick(() => {
        if (this.$refs.map && this.$refs.map.onReset) {
          this.$refs.map.onReset()
        }
        if (this.$refs.table && this.$refs.table.reload) {
          this.$refs.table.reload()
        }
      })
    },
  },
}
</script>
<style scoped>
@media only screen and (min-width: 600px) {
  .datastore-main-edit-container {
    max-height: calc(100vh - 60px - 40px - 45px - 40px - 150px) !important;
    padding-bottom: 80px;
  }
}
</style>
